import { render, staticRenderFns } from "./Create-Property.vue?vue&type=template&id=053270af"
import script from "./Create-Property.vue?vue&type=script&lang=js"
export * from "./Create-Property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports